import 'css-chunksrc/client/pages/projectPage/timeSheetPage/filters/styles.scss';export default {
  "filters": "_filters_iy79v_1",
  "resetButton": "_resetButton_iy79v_17",
  "label": "_label_iy79v_25",
  "section": "_section_iy79v_32"
};